import { cx } from "../../lib/cx";

// Verbatim from the live Case Studies and Blog pages.
export const industryStats = [
  {
    value: "42%",
    label:
      "of construction projects experience cost overruns due to inaccurate data.",
  },
  {
    value: "$156 billion",
    label: "annually in wasted spending due to fragmented data.",
  },
  {
    value: "30%",
    label: "of rework in construction is due to miscommunication and errors",
  },
];

export const wastedLine =
  "Too much time, energy, money, and momentum is wasted by using generic software not built for you.";

/** The live site's closing statistics: three big yellow figures. */
export default function StatsBand({ dark = true }) {
  return (
    <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
      {industryStats.map(({ value, label }) => (
        <div key={value} className="text-center">
          <div
            className={cx(
              "font-display mb-3 text-5xl md:text-6xl",
              dark ? "text-yellow" : "text-ink",
            )}
          >
            {value}
          </div>
          <p
            className={cx(
              "mx-auto max-w-[28ch]",
              dark ? "text-on-dark-muted" : "text-ink-3",
            )}
          >
            {label}
          </p>
        </div>
      ))}
    </div>
  );
}
